import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import type { TaskListAnchor } from "./useTaskListSubscription";

export function AnchorsSubTable(props: { anchors: TaskListAnchor[]; isHomepage: boolean }) {
  const countLabel = props.isHomepage ? "Сайты-доноры" : "Кол-во статей";
  const countTooltip = props.isHomepage
    ? "Количество сайтов-доноров для размещения предложений"
    : "Количество генерируемых статей на анкор";

  return (
    <Box sx={{ py: 1, pl: 6 }}>
      <Typography variant="subtitle2" gutterBottom>
        Анкоры
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Текст анкора</TableCell>
            <TableCell align="right">
              <Tooltip title={countTooltip}>
                <span>{countLabel}</span>
              </Tooltip>
            </TableCell>
            <TableCell>Статус</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.anchors.map((anchor) => (
            <TableRow key={anchor.id}>
              <TableCell>{anchor.anchorText}</TableCell>
              <TableCell className="tabular-nums" align="right">{anchor.articleCount}</TableCell>
              <TableCell>{anchor.status}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}
